//
// Event has no function constructor in IE
// This polyfill assumes we've already polyfilled CustomEvent
//
;(function(window) {
  if(typeof window.Event !== "function") {
    window.Event = window.CustomEvent;
  };
})(window);



// WEBPACK FOOTER //
// ./app/javascript/lib/event_func_constructor_polyfill.js